import { render, staticRenderFns } from "./PageSeven.vue?vue&type=template&id=bace1878&scoped=true"
import script from "./PageSeven.vue?vue&type=script&lang=js"
export * from "./PageSeven.vue?vue&type=script&lang=js"
import style0 from "./PageSeven.vue?vue&type=style&index=0&id=bace1878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bace1878",
  null
  
)

export default component.exports